import api, { API_1, UPLOAD_API, WORKSHOP_API } from "../axiosInstance";

const vehicleSummaryService = {
  fetchSummary: (leadId) => api.get(`vehicle/${leadId}/summary`),
  fetchVehicleDetails: (leadId) => api.get(`vehicle/v2/${leadId}/summary`),
  postBdmRequest: (leadId, data) => api.post(`vehicle/${leadId}/bdm/action`, data),
  postAdminResponse: (leadId, data) => api.post(`vehicle/${leadId}/admin/action`, data),
  downloadAttachments: (fileName, uploadType) => {
    let apiFileName = fileName;

    if (fileName.includes("#")) {
      const idx = fileName.indexOf("#");

      apiFileName = `${apiFileName.substr(0, idx)}%23${apiFileName.substr(idx + 1)}`;
    }
    if (uploadType) {
      return API_1.get(`file/${apiFileName}${uploadType}`);
    }
    return API_1.get(`file/${apiFileName}`);
  },
  getDataValidation: (appointmentId) => api.get(`vehicle/${appointmentId}/data-validation`),
  postDataValidation: (appointmentId, payload) => api.post(`vehicle/${appointmentId}/data-validation`, payload),
  syncEEData: (appointmentId, isRefreshNvicTrue) =>
    api.post(`vehicle/${appointmentId}/sync?provider=EE&refreshNvic=${isRefreshNvicTrue}`),
  photographyQcComplete: (appointmentId) => api.post(`vehicle/${appointmentId}/photographyQC`),
  getServiceHistory: (appointmentId) => api.get(`serviceHistory?appointmentId=${appointmentId}`),
  fetchWarrantyDetails: (appointmentId) => api.get(`warranty?appointmentId=${appointmentId}`),
  getPrice: (appointmentId, pageSize) => api.get(`price?appointmentId=${appointmentId}&page=0&size=${pageSize}`),
  updateWarranty: (payload) => api.post(`warranty`, payload),
  validatePrice: (payload) => api.post(`price/validate`, payload),
  updatePrice: (payload) => api.post(`vehicle`, payload),
  addHolds: (payload) => api.post(`holds`, payload),
  getHolds: (appointmentId, isActive) => api.get(`holds?appointmentId=${appointmentId}&isActive=${isActive}`),
  markAsResolved: (payload) => api.post(`holds`, payload),
  getPrimaryVehicleDetails: (appointmentId) => api.get(`vehicle/masterData?appointmentId=${appointmentId}`),
  getChecklist: (appointmentId) => api.get(`vehicle/checklist?appointmentId=${appointmentId}`),
  getMarketplaceData: (appId) => api.get(`marketplace/vehicle?appointmentId=${appId}`),
  postMarketplaceData: (payload) => api.post(`marketplace/vehicle`, payload),
  resetMarketplaceCards: (appId, cardName) => api.put(`marketplace/vehicle/${appId}/reset/${cardName}`),
  getRecallTab: (leadId, isActive) => api.get(`recallDetail/${leadId}?isActive=${isActive}`),
  viewRecall: (recallId) => api.get(`recallDetail/view/${recallId}`),
  updateStage: (recallId, payload) => api.post(`recallDetail?recallId=${recallId}`, payload),
  bulkUpdateStage: (payload) => api.post(`recallDetail/bulk`, payload),
  updateAfterAddRecall: (payload) => api.post(`recallDetail`, payload),
  viewRecallFile: (fileName) => api.get(`file/${fileName}?uploadType=RECALL_INVOICE`),
  updateInitialCheckStage: (leadId, action) =>
    api.put(`/vehicle/${leadId}/recall`, {
      action,
      isInitialCheck: true
    }),
  addInitialCheckRecall: (payload) => api.post(`recallDetail?isInitialCheck=true`, payload),
  updateVin: (leadId, payload) => api.post(`vehicle/${leadId}/action/UPDATE_VIN`, payload),
  fetchReviewTab: (appId) => WORKSHOP_API.get(`/review/${appId}/summary`),
  updateRegoDoc: (payload) => api.post(`/vehicle/updateRegoDoc`, payload),
  fetchSoldQCDetails: (appointmentId) => api.get(`/refurb/movement/appointment/${appointmentId}/catalog/SOLD_QC`),
  fetchVideographyPremiumFeaturesTag: (appointmentId) =>
    UPLOAD_API.get(`refurb/jobCart/premium-features?appointmentId=${appointmentId}`),
  fetchVideographyPrompt: (appointmentId) => api.get(`/api/v1/videography/prompt?appointmentId=${appointmentId}`),
  updateVideographyPrompt: (appointmentId, payload) =>
    api.put(`/api/v1/videography/prompt?appointmentId=${appointmentId}`, payload),
  fetchVideographyWorkstationDetails: (appointmentId) =>
    api.get(`/api/v1/videography/workstation?appointmentId=${appointmentId}`),
  fetchProcessTrackerDetails: (trackerId) => api.get(`/api/v1/videography/process-tracker?id=${trackerId}`),
  completeVideographyQcAction: (appointmentId, action, jobId) =>
    api.put(
      `/api/v1/videography/workstation/action?appointmentId=${appointmentId}&action=${action}${
        jobId ? `&jobId=${jobId}` : ""
      }`
    ),
  updateVideographyWorkstationData: (appointmentId, payload) =>
    api.put(`/api/v1/videography/workstation?appointmentId=${appointmentId}`, payload),
  fetchVideographyFinalVideoDetails: (appointmentId) =>
    api.get(`/api/v1/videography/final-video?appointmentId=${appointmentId}`),
  updateVideographyFinalVideoDetails: (payload, isReupload, assetUpdate) => {
    const params = new URLSearchParams({
      reUpload: isReupload ? "true" : "false",
      assetUpdate: assetUpdate ? "true" : "false"
    });

    return api.put(`/api/v1/videography/final-video?${params.toString()}`, payload);
  },
  uploadFinalVideoPlatform: (payload) => api.post(`/api/v1/videography/upload`, payload),
  checkFinalVideoPlatformStatus: (appointmentId) =>
    api.get(`/api/v1/videography/upload/status?appointmentId=${appointmentId}`),
  publishFinalVideo: (appointmentId) => api.post(`/api/v1/videography/complete?appointmentId=${appointmentId}`),
  generateFinalVideoChapterGif: (appointmentId, chapterId) =>
    api.post(`/api/v1/videography/generate-chapter-asset?id=${chapterId}&appointmentId=${appointmentId}`),
  updateVehicleSegment: (appointmentId) => api.post(`vehicle/update/segment?appointmentId=${appointmentId}`),
  prePublishCar: (appointmentId) => api.post(`vehicle/${appointmentId}/prePublish`),
  updateEstimatedRefurbDate: (appointmentId, payload) => api.post(`/vehicle/${appointmentId}/refurbEstimate`, payload),
  stitchFinalVideo: (appointmentId) =>
    api.post(`/api/v1/videography/final-video/video-stitch?appointmentId=${appointmentId}`),
  checkFinalVideoStitchStatus: (appointmentId) =>
    api.get(`/api/v1/videography/final-video/status?appointmentId=${appointmentId}`),
  approveVehicleStage: (caseId, stageType) => api.post(`vehicle/approval/${caseId}/stage/${stageType}/approve`),
  sendBackVehicleStage: (caseId, stageType, body) =>
    api.post(`vehicle/approval/${caseId}/stage/${stageType}/send-back`, body)
};

export default vehicleSummaryService;
